import { axios } from "../../lib/axios";

export const DeleteFAQ = (faqId: string) => {
    return axios.delete(`/faq/${faqId}`)
        .then(response => response.data);
};